import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ModalService, PatientService } from '../../services';

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss']
})
export class DocumentPreviewComponent implements OnChanges, OnDestroy {
  @Input() document: any;
  @Output() close = new EventEmitter<void>();

  isLoading = false;
  isImage = false;
  isPdf = false;
  fileUrl: SafeResourceUrl | null = null;
  private objectUrl: string | null = null;

  constructor(
    private patientService: PatientService,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private modalService: ModalService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.document && this.document) {
      this.loadPreview();
    }
  }

  get nameOfFile(): string {
    return this.document ? (this.document.name_of_file || this.document.nameOfFile) : '';
  }

  private loadPreview() {
    this.revokeUrl();
    this.fileUrl = null;
    this.isLoading = true;

    const extension = (this.nameOfFile || '').split('.').pop().toLowerCase();
    this.isImage = IMAGE_EXTENSIONS.includes(extension);
    this.isPdf = extension === 'pdf';

    this.patientService.getDocumentFromDocumentation(this.nameOfFile).subscribe(
      data => {
        const binaryData = atob(data.data);
        const len = binaryData.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryData.charCodeAt(i);
        }

        const mimeType = this.isImage ? `image/${extension === 'jpg' ? 'jpeg' : extension}` : 'application/pdf';
        const blob = new Blob([bytes.buffer], { type: mimeType });
        this.objectUrl = URL.createObjectURL(blob);
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
        this.modalService.open(this.translate.instant('BACKEND.COULDNT-GET-DATA'), undefined, undefined, 'EVENTS.SHARED.COMPONENTS.DOCUMENT-PREVIEW.POPUP.BACKEND-COULDNT-GET-DATA');
      }
    );
  }

  private revokeUrl() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  }

  closePreview() {
    this.close.emit();
  }

  onOverlayClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('document-preview-overlay')) {
      this.closePreview();
    }
  }

  ngOnDestroy() {
    this.revokeUrl();
  }
}
